import i18next from 'i18next';
import englishMessages from 'ra-language-english';
import spanishMessages from 'aor-language-spanish';
import merge from 'lodash/merge';

import { setApiLanguage } from './api';

function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
}

i18next
  .init({
    lng: localStorage.getItem('language') || 'es',
    fallbackLng: 'es',
    initImmediate: false,
    interpolation: {
      escapeValue: false
    }
  });

i18next.on('languageChanged', (lng: string) => setApiLanguage(lng));

requireAll(require.context('..', true, /i18n\.tsx$/));

function getSpanishMessages() {
  spanishMessages.ra.action.confirm = 'Confirmar';
  spanishMessages.ra.message.delete_title = "Eliminar";
  spanishMessages.ra.message.delete_content = "¿Seguro que quiere eliminar este elemento?";
  spanishMessages.ra.message.bulk_delete_title = "Eliminar";
  spanishMessages.ra.message.bulk_delete_content = "¿Seguro que quiere eliminar este elemento? |||| ¿Seguro que quiere eliminar estos elementos?";
  spanishMessages.ra.message.export_title = "exportar";
  spanishMessages.ra.action.export = "Exportar";
  spanishMessages.ra.action.search = "Buscar";
  spanishMessages.ra.navigation.no_results = "No hay proyectos ni acciones para este territorio";
  spanishMessages.ra.page.empty = "No hay proyectos ni acciones para este territorio";
  spanishMessages.ra.page.invite = "¿Querés agregar uno?";
  spanishMessages.ra.sort = {
    ...spanishMessages.ra.sort,
    DESC: "Descendente",
    ASC: "Ascendente"
  };
  return spanishMessages;
}

function getEnglishMessages() {
  englishMessages.ra.action.confirm = 'Confirm';
  englishMessages.ra.message.delete_title = "Delete";
  englishMessages.ra.message.delete_content = "Are you sure you want to delete this item?";
  englishMessages.ra.message.bulk_delete_title = "Delete";
  englishMessages.ra.message.bulk_delete_content = "Are you sure you want to delete this item? |||| Are you sure you want to delete these items?";
  englishMessages.ra.message.export_title = "export";
  englishMessages.ra.action.export = "Export";
  englishMessages.ra.action.search = "Search";
  englishMessages.ra.navigation.no_results = "No projects or actions for this territory";
  englishMessages.ra.page.empty = "No projects or actions for this territory";
  englishMessages.ra.page.invite = "Do you want to add one?";
  englishMessages.ra.sort = {
    ...englishMessages.ra.sort,
    DESC: "Descending",
    ASC: "Ascending"
  };
  return englishMessages;
}

function getPortugueseMessages() {
  const portugueseMessages = merge({}, englishMessages);
  portugueseMessages.ra.action.confirm = 'Confirmar';
  portugueseMessages.ra.message.delete_title = "Eliminar";
  portugueseMessages.ra.message.delete_content = "Tem certeza que deseja eliminar este elemento?";
  portugueseMessages.ra.message.bulk_delete_title = "Eliminar";
  portugueseMessages.ra.message.bulk_delete_content = "Tem certeza que deseja eliminar este elemento? |||| Tem certeza que deseja eliminar estes elementos?";
  portugueseMessages.ra.message.export_title = "exportar";
  portugueseMessages.ra.action.export = "Exportar";
  portugueseMessages.ra.action.search = "Buscar";
  portugueseMessages.ra.navigation.no_results = "Não há projetos nem ações para este território";
  portugueseMessages.ra.page.empty = "Não há projetos nem ações para este território";
  portugueseMessages.ra.page.invite = "Você quer adicionar um?";
  portugueseMessages.ra.sort = {
    ...portugueseMessages.ra.sort,
    DESC: "Descendente",
    ASC: "Ascendente"
  };
  return portugueseMessages;
}

export const messages = {
  en: { ...getEnglishMessages() },
  es: { ...getSpanishMessages() },
  pt: { ...getPortugueseMessages() }
};

export const i18nProvider = locale => messages[locale];
